import {lazy} from 'react'
import {Route, Switch} from 'react-router-dom'
import {Container} from '../../modules/components'

export enum ManagementsRoutesEnum {
    DatatablePreCompanies = '/gestao/pre-empresas',
    StorePreCompany = '/gestao/pre-empresas/cadastrar',
    ShowPreCompany = '/gestao/pre-empresas/:id',
    DatatableCompanies = '/gestao/empresas',
    ShowCompany = '/gestao/empresas/:id',
}

export default function ManagementsRouter() {
    /*Rotas para Usuários*/
    const DatatablePreCompanies = lazy(
        () => import('../../pages/managements/pre_companies/DatatablePreCompany')
    )
    const ShowPreCompany = lazy(
        () => import('../../pages/managements/pre_companies/ShowPreCompany')
    )
    const StorePreCompany = lazy(
        () => import('../../pages/managements/pre_companies/StorePreCompany')
    )

    const DatatableCompanies = lazy(
        () => import('../../pages/managements/companies/DatatableCompany')
    )
    const ShowCompany = lazy(() => import('../../pages/managements/companies/ShowCompany'))

    return (
        <Container loading={false}>
            <Switch>
                <Route path={ManagementsRoutesEnum.StorePreCompany} component={StorePreCompany} />
                <Route path={ManagementsRoutesEnum.ShowPreCompany} component={ShowPreCompany} />
                <Route
                    path={ManagementsRoutesEnum.DatatablePreCompanies}
                    component={DatatablePreCompanies}
                />

                <Route path={ManagementsRoutesEnum.ShowCompany} component={ShowCompany} />
                <Route
                    path={ManagementsRoutesEnum.DatatableCompanies}
                    component={DatatableCompanies}
                />
            </Switch>
        </Container>
    )
}
